import {
  TIPO_MOVIMENTACAO_ESTOQUE_ENTRADA,
  TIPO_MOVIMENTACAO_ESTOQUE_SAIDA,
  ORIGEM_MOVIMENTACAO_ESTOQUE_COMPRA,
  ORIGEM_MOVIMENTACAO_ESTOQUE_VENDA,
  ORIGEM_MOVIMENTACAO_ESTOQUE_AVARIA,
  ORIGEM_MOVIMENTACAO_ESTOQUE_CORRECAO,
  ORIGEM_MOVIMENTACAO_ESTOQUE_DEVOLUCAO_VENDA,
  ORIGEM_MOVIMENTACAO_ESTOQUE_AJUSTE_STATUS_PRODUTO,
} from '../../utils';

const choicesTipo = [
  { id: TIPO_MOVIMENTACAO_ESTOQUE_ENTRADA, name: 'Entrada' },
  { id: TIPO_MOVIMENTACAO_ESTOQUE_SAIDA, name: 'Saída' },
];

const choicesOrigem = [
  { id: ORIGEM_MOVIMENTACAO_ESTOQUE_VENDA, name: 'Venda' },
  { id: ORIGEM_MOVIMENTACAO_ESTOQUE_COMPRA, name: 'Compra' },
  { id: ORIGEM_MOVIMENTACAO_ESTOQUE_AVARIA, name: 'Avaria' },
  { id: ORIGEM_MOVIMENTACAO_ESTOQUE_CORRECAO, name: 'Correção de Estoque' },
  {
    id: ORIGEM_MOVIMENTACAO_ESTOQUE_DEVOLUCAO_VENDA,
    name: 'Devolução de Venda',
  },
  {
    id: ORIGEM_MOVIMENTACAO_ESTOQUE_AJUSTE_STATUS_PRODUTO,
    name: 'Ajuste por Status do Produto',
  },
];

export { choicesOrigem, choicesTipo };
